import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import CopyLink from './icon-copy-link.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CopyLink {...validProps} />;
}
SvgComponent.iconName = 'copyLink';

export const CopyLinkIcon = svgIconWrapper(SvgComponent);
